import React from "react";
import GpsMapWrapper from "../components/GpsMapWrapper";

// 지도는 민트캠 GPS만 보여준다.
//   민트워치 안내문구·파란 마커는 2026-10-07 제거했다(삼우에 민트워치를 넣지 않기로 함).
export default function MapPage() {
  return (
    <div className="bg-white dark:bg-[#1F2A3B] p-4 sm:p-6 rounded-xl shadow-md min-w-0">
      <h3 className="text-base sm:text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">
        GPS 지도
      </h3>

      <div className="mb-4 rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-400/20 dark:bg-blue-400/10 dark:text-blue-200">
        <div className="font-semibold">실시간 위치</div>
        <div className="mt-1 leading-6">
          <span className="font-semibold text-green-700 dark:text-green-300">● 민트캠</span>의 GPS 위치를 표시합니다.
          위치 권한이 허용되고 측위된 단말만 지도에 나타납니다.
        </div>
      </div>

      <div className="h-[70vh] min-h-[500px]">
        <GpsMapWrapper />
      </div>
    </div>
  );
}